// ============================================
// CHÁMOMILE — Firebase Upload Utilities
// ============================================
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, storage, isFirebaseConfigured } from '../config/firebase';
import { ImageUtils } from './browser';

// Compressed Upload Function
export const uploadReceiptToFirebase = async (file, orderId, onProgress) => {
    if (!isFirebaseConfigured() || !storage) {
        console.log('⚠️ Firebase Storage not configured, using base64 fallback');
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    try {
        // Step 1: Try to compress (may fail in Instagram/embedded browsers)
        let fileToUpload = file;
        try {
            onProgress && onProgress('Compressing image...');
            fileToUpload = await ImageUtils.compressImage(file, { maxWidth: 1200, maxHeight: 1200, quality: 0.8 });
            console.log('✅ Image compressed successfully');
        } catch (compressError) {
            console.warn('⚠️ Image compression failed (embedded browser?), using original file:', compressError);
            fileToUpload = file; // fallback to raw file
        }

        // Step 2: Try Firebase Storage upload
        try {
            const fileExt = 'jpg';
            const fileName = `payment-receipts/${orderId}-${Date.now()}.${fileExt}`;
            const storageRef = ref(storage, fileName);

            onProgress && onProgress('Uploading receipt...');
            const snapshot = await uploadBytes(storageRef, fileToUpload);
            const downloadURL = await getDownloadURL(snapshot.ref);
            console.log('✅ Receipt uploaded to Firebase Storage');
            return downloadURL;
        } catch (uploadError) {
            console.warn('⚠️ Firebase Storage upload failed, using base64 fallback:', uploadError);
        }

        // Step 3: Base64 fallback
        onProgress && onProgress('Saving receipt...');
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                console.log('✅ Receipt saved as base64 fallback');
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    } catch (error) {
        console.error('❌ All upload methods failed:', error);
        // Ultimate fallback — just return a placeholder so the order can still submit
        return 'receipt-upload-failed-see-customer';
    }
};

export const saveOrderToFirebase = async (orderData) => {
    if (!isFirebaseConfigured() || !db) {
        console.log('⚠️ Firebase not configured, saving to localStorage');
        try {
            const orders = JSON.parse(localStorage.getItem('chamomile-online-orders') || '[]');
            orders.push({ ...orderData, createdAt: new Date().toISOString() });
            localStorage.setItem('chamomile-online-orders', JSON.stringify(orders));
        } catch (e) { console.warn('localStorage error:', e); }
        return;
    }
    try {
        await addDoc(collection(db, 'online-orders'), { ...orderData, createdAt: serverTimestamp(), updatedAt: serverTimestamp() });
    } catch (error) { 
        console.error('❌ Firestore save error:', error); 
        throw error; 
    }
};
